<template>
  <wtFormRight>
    <!-- -TOOLBARS -->
    <template slot="toolbars">
      <Toolbars
        :objProps="objItem"
        :objPropsData="objItemData"
        :urlServices="urlServices"
        :primary_key="primary_key"
        :nameObjData="nameObjData"
        :requiredEndDt="requiredEndDt"
        :noDelete="noDelete"
        :noModify="noModify"
      />
    </template>

    <!-- VIEW TABLE -->
    <template slot="table" v-if="showGrid">
      <SupportTicketActivityGrid
        @selectedSupportTicketActivity="objRowSelected = $event"
      ></SupportTicketActivityGrid>
    </template>

    <!-- VIEW FORM -->
    <template slot="form" v-if="!showGrid">
      <div class="wt-h-100" @contextmenu.prevent="$refs.menu.open($event, contextMenu)">
         <vue-step :now-step="step+1" :step-list="stepList" class="mb-2 mx-5"></vue-step>

        <b-form class="text-uppercase">
          <!-- Line 01 -->
          <div class="form-row">
            <div class="form-group col-md-5">
              <label for="support_ticket_activity_support_ticket_activity_id">id</label>
              <input
                id="support_ticket_activity_support_ticket_activity_id"
                type="text"
                class="form-control"
                v-model.trim="objItem.support_ticket_activity_id"
                readonly
              />
            </div>

            <div class="form-group col-md-5">
              <label for="support_ticket_activity_activity_status">activity_status</label>
              <b-form-select
                id="support_ticket_activity_activity_status"
                class="form-control"
                :options="activityStatus"
                v-model="objItemData.activity_status"
                disabled
              />
            </div>

            <div class="form-group col-md-2">
              <label
                for="support_ticket_activity_used_minutes_total"
              >used minutes total</label>
              <input
                id="support_ticket_activity_used_minutes_total"
                type="text"
                class="form-control"
                v-model.trim="objItemData.used_minutes_total"
                readonly
              />
            </div>
          </div>

          <!-- SCHEDULED -->
          <Accordion :accordionOptions="accordionOptions">
            <template slot="accordion-0">
              <div class="form-row">                
                <div class="form-group col-md-5">
                  <label for="support_ticket_activity_scheduled_activity">Scheduled Activity</label>
                  <b-form-select
                    id="support_ticket_activity_scheduled_activity"
                    class="form-control"
                    :options="scheduledActivity"
                    v-model="objItemData.scheduled_activity"
                    :disabled="step!==0"
                  />
                </div>

                 <div class="form-group col-md-2">
                  <label for="support_ticket_activity_schedule_time">schedule time</label>
                  <input
                    id="support_ticket_activity_schedule_time"
                    type="text"
                    class="form-control"
                    v-model.trim="objItemData.schedule_time"
                    :disabled="step!==0"
                  />
                </div>

                <div class="form-group col-md-2">
                  <label for="support_ticket_activity_time_type_classification">time type</label>
                  <b-form-select
                    id="support_ticket_activity_time_type_classification"
                    class="form-control"
                    :options="timeTypesClassification"
                    v-model="objItemData.time_type_classification"
                    :disabled="step!==0"
                  />
                </div>

                <div class="form-group col-md-3">
                  <label
                    for="support_ticket_activity_used_minutes_scheduled">used minutes scheduled</label>
                  <input
                    id="support_ticket_activity_used_minutes_scheduled"
                    type="text"
                    class="form-control"
                    v-model.trim="objItemData.used_minutes_scheduled"
                    readonly
                  />
                </div>

                <div class="form-group col-md-12">
                  <label for="support_ticket_activity_detailing_scheduled">detailing scheduled</label>
                  <VueEditor v-model="objItemData.detailing_scheduled" :disabled="step!==0"/>
                </div>               

                <div class="form-group col-md-4">
                  <label for="support_ticket_activity_scheduled_init_dt">scheduled init dt</label>
                  <input
                    id="support_ticket_activity_scheduled_init_dt"
                    type="datetime"
                    class="form-control"
                    v-model.trim="objItemData.scheduled_init_dt"
                    readonly
                  />
                </div>

                <div class="form-group col-md-4">
                  <label for="support_ticket_activity_scheduled_end_dt">scheduled end dt</label>
                  <input
                    id="support_ticket_activity_scheduled_end_dt"
                    type="datetime"
                    class="form-control"
                    v-model.trim="objItemData.scheduled_end_dt"
                    readonly
                  />
                </div>

                <div class="form-group col-md-4">
                  <label for="support_ticket_activity_user_name_scheduled">user name scheduled</label>
                  <input
                    id="support_ticket_activity_user_name_scheduled"
                    type="text"
                    class="form-control"
                    v-model.trim="objItemData.user_name_scheduled"
                    readonly
                  />
                </div>
              </div>
            </template>

            <!-- EXECUTION -->
            <template slot="accordion-1">
              <div class="form-row">
                <div class="form-group col-md-9">
                  <label for="support_ticket_activity_execution_status">execution status</label>
                  <b-form-select
                    id="support_ticket_activity_execution_status"
                    class="form-control"
                    :options="executionStatus"
                    v-model="objItemData.execution_status"
                    disabled
                  />
                </div>

                <div class="form-group col-md-3">
                  <label
                    for="support_ticket_activity_used_minutes_execution">used minutes execution</label>
                  <input
                    id="support_ticket_activity_used_minutes_execution"
                    type="text"
                    class="form-control"
                    v-model.trim="objItemData.used_minutes_execution"
                    readonly
                  />
                </div>

                <div class="form-group col-md-12">
                  <label for="support_ticket_activity_detailing_execution">detailing execution</label>
                  <VueEditor v-model="objItemData.detailing_execution" :disabled="step<2"/>
                </div>
                
                <div class="form-group col-md-3">
                  <label for="support_ticket_activity_execution_init_dt">execution init dt</label>
                  <input
                    id="support_ticket_activity_execution_init_dt"
                    type="datetime"
                    class="form-control"
                    v-model.trim="objItemData.execution_init_dt"
                    readonly
                  />
                </div>
                
                <div class="form-group col-md-3">
                  <label for="support_ticket_activity_user_name_init_execution">user name init execution</label>
                  <input
                    id="support_ticket_activity_user_name_init_execution"
                    type="text"
                    class="form-control"
                    v-model.trim="objItemData.user_name_init_execution"
                    readonly
                  />
                </div>

                <div class="form-group col-md-3">
                  <label for="support_ticket_activity_execution_end_dt">execution end dt</label>
                  <input
                    id="support_ticket_activity_aexecution_end_dt"
                    type="datetime"
                    class="form-control"
                    v-model.trim="objItemData.execution_end_dt"
                    readonly
                  />
                </div>

                <div class="form-group col-md-3">
                  <label for="support_ticket_activity_user_name_end_execution">user name end execution</label>
                  <input
                    id="support_ticket_activity_user_name_end_execution"
                    type="text"
                    class="form-control"
                    v-model.trim="objItemData.user_name_end_execution"
                    readonly
                  />
                </div>
              </div>
            </template>
          </Accordion>
        </b-form>
        <!-- Context Menu -->
        <ContextMenu ref="menu">
          <template slot-scope="{}">
            <ContextMenuItem
              v-for="(item, index) in contextMenu.actions"
              :key="index"
              @click.native="$refs.menu.executeAction(index)"
            >{{ item.action }}</ContextMenuItem>
          </template>
        </ContextMenu>
      </div>
    </template>
  </wtFormRight>
</template>
<script>
/** RECURSOS DO VUE **/
import { baseApiUrl, baseApiPort } from "@/global";
import axios from "axios";
import moment from "moment";
import vueStep from 'vue-step'

/* COMPONENTS - LAYOUT */
import wtFormRight from "@/components/forms/wtFormRight";
import Toolbars from "@/components/widgets/Toolbars";
import Accordion from "@/components/widgets/Accordion";
import { VueEditor } from "vue2-editor";
import ContextMenu from "@/components/widgets/context-menu/ContextMenu";
import ContextMenuItem from "@/components/widgets/context-menu/ContextMenuItem";

/* COMPONENTS - PAGE */
import SupportTicketActivityGrid from "./SupportTicketActivityGrid";

export default {
  name: "SupportTicketActivity",
  props: {},

  /* COMPONENTS IN USE */
  components: {
    wtFormRight,
    Toolbars,
    Accordion,
    VueEditor,
    vueStep,
    ContextMenu,
    ContextMenuItem,
    SupportTicketActivityGrid
  },

  /* COMPUTED VARIABLES */
  computed: {
    showGrid() {
      return this.$store.state.layout.showGrid;
    },
    urlServicesStore() {
      return this.$store.state.urlServicesStore;
    },
    objShared() {
      return this.$store.state.objShared;
    },
    objSelected() {
      return this.$store.state.objSelected;
    },
    action() {
      return this.$store.state.action;
    }
  },

  /* VARIABLES */
  data: function() {
    return {
      /* Controls */
      urlServices: "support-ticket-ds/api/internal/support-ticket-activity",
      primary_key: "support_ticket_activity_id",

      /* Objects Page */
      objItem: {},
      objItemData: {},
      objRowSelected: {},
      nameObjData: "support_ticket_activity_data",
      requiredEndDt: false,
      noDelete: false,
      noModify: false,
      visible: false,
      step: 0,
      /* Context Menu Options */
      contextMenu: {
        row: [],
        actions: []
      },
      contextMenuOptions: [
        {action: "Authorize Execution", urlAction: "support-ticket-ds/api/internal/support-ticket-activity/authorize-execution", key: "support_ticket_activity_id" },
        {action: "Start Execution", urlAction: "support-ticket-ds/api/internal/support-ticket-activity/start-execution", key: "support_ticket_activity_id" },
        {action: "Release for Test", urlAction: "support-ticket-ds/api/internal/support-ticket-activity/release-test", key: "support_ticket_activity_id" },
        {action: "Finish Execution", urlAction: "support-ticket-ds/api/internal/support-ticket-activity/finish-execution", key: "support_ticket_activity_id" },
       
      ],
      accordionOptions: [
        { title: "scheduled ", state: "open" },
        { title: "Execution", state:"open" }
      ],
      activityStatus: [{ value: null, text: "---" }],
      scheduledActivity:  [{ value: null, text: "---" }],
      timeTypesClassification: [{ value: null, text: "---" }],
      executionStatus: [{ value: null, text: "---" }],

      nowStep: 0,
      stepList: [
        'EXPECTED',
        'SCHEDULED',
        'RUNNING',
        'VALIDATION',
        'PERFORMED'        
      ]
    };
  },

  /* METHODS */
  methods: {
    load(objItem) {
      this.$store.commit("setShowLoading", true);
      this.$store.commit("setShowGrid", false);

      const param = {};
      param[`${this.primary_key}`] = objItem[`${this.primary_key}`];
      const url = `${baseApiUrl}:${baseApiPort}/${this.urlServices}/find/`;

      axios.post(url, param).then(res => {        
        this.objItem = res.data[0];
        this.objItemData = this.objItem[`${this.nameObjData}`];
        this.updatingActionContextMenu();
        this.updatingStep()
        this.noModify = this.objItemData.scheduled_end_dt !== null;
        this.$store.commit("setShowLoading", false);
      });
    },

    updatingStep(){
      if(this.objItemData.activity_status === 'EXPECTED'){
        this.step=0;
      }
      if(this.objItemData.activity_status === 'SCHEDULED'){
        this.step=1;
      }
      if(this.objItemData.activity_status === 'RUNNING'){
        this.step=2;
      }
      if(this.objItemData.activity_status === 'VALIDATION'){
        this.step=3;
      }
      if(this.objItemData.activity_status === 'PERFORMED'){
        this.step=4;  
      }
    },
    updatingActionContextMenu() {
      const options = [];     
      if (this.objItemData.activity_status === 'EXPECTED') {
        options.push(this.contextMenuOptions[0]);
        this.noDelete = true;
      } else if (this.objItemData.activity_status === 'SCHEDULED') {
        options.push(this.contextMenuOptions[1]);
      } else if (this.objItemData.activity_status === 'RUNNING') {
        options.push(this.contextMenuOptions[2]);
      } else if (this.objItemData.activity_status === 'VALIDATION') {
        options.push(this.contextMenuOptions[3]);
      }
      this.contextMenu.row = this.objItem;
      this.contextMenu.actions = options;
    },
    getActivityStatus() {
      const urlService =
        "support-ticket-ds/api/internal/support-ticket-activity";
      axios
        .post(
          `${baseApiUrl}:${baseApiPort}/${urlService}/find-all-activity-status`
        )
        .then(res => {
          res.data.forEach(element => {
            this.activityStatus.push({
              value: element.description,
              text: element.description.split("_").join(" ")
            });
          });
        });
    },
    getScheduledActivity() {
      const urlService =
        "support-ticket-ds/api/internal/support-ticket-activity";
      axios
        .post(
          `${baseApiUrl}:${baseApiPort}/${urlService}/find-all-scheduled-activity`
        )
        .then(res => {
          res.data.forEach(element => {
            this.scheduledActivity.push({
              value: element.description,
              text: element.description.split("_").join(" ")
            });
          });
        });
    },
    getTimeTypesClassification() {
      const urlService =
        "support-ticket-ds/api/internal/support-ticket-activity";
      axios
        .post(
          `${baseApiUrl}:${baseApiPort}/${urlService}/find-all-time-types-classification`
        )
        .then(res => {
          res.data.forEach(element => {
            this.timeTypesClassification.push({
              value: element.description,
              text: element.description.split("_").join(" ")
            });
          });
        });
    },
    getExecutionStatus() {
      const urlService =
        "support-ticket-ds/api/internal/support-ticket-activity";
      axios
        .post(
          `${baseApiUrl}:${baseApiPort}/${urlService}/find-all-execution-status`
        )
        .then(res => {
          res.data.forEach(element => {
            this.executionStatus.push({
              value: element.description,
              text: element.description.split("_").join(" ")
            });
          });
        });
    }
  },

  /* WATCH */
  watch: {
    objRowSelected() {
      this.load(this.objRowSelected);
      this.$store.commit("setAction", "modify");
    },
    objSelected() {
      if (this.urlServicesStore === this.urlServices) {
        if (Object.entries(this.objSelected).length === 0) {
          this.$emit("supportTicketSelected", null);
        } else {
          this.$emit(
            "supportTicketSelected",
            this.objSelected.support_ticket_id
          );
        }
      }
    },
    action() {
      if (this.urlServicesStore === this.urlServices) {
        if (this.action === "add") {
          console.log('action:', this.action)
          this.objItemData.support_ticket_id = this.objSelected.support_ticket_id;
          this.noModify = false;
          this.noDelete = false;
          this.step = 0;
        } else if (this.action === "reset") {
          console.log('action:', this.action)
          this.objItem = {};
          this.objItemData = {};
          this.noModify = false;
          this.noDelete = false;
          this.step = 0;
        }
      }
    },
    objItemData() {
      if (this.urlServicesStore === this.urlServices) {
        if (Object.entries(this.objItemData).length > 0) {
          if(this.action !== 'MODIFY') {
            this.objItemData.activity_status = "EXPECTED";
            this.objItemData.scheduled_init_dt = moment().format("YYYY-MM-DD HH:mm:ss");
          }
        }
      }
    },
    step(){
      if(this.step === 0) {
        this.noModify = false
        this.noDelete = false
      } else if (this.step === 1) {
        this.noModify = false
        this.noDelete = true
      } else if (this.step === 2) {
        this.noModify = false
        this.noDelete = true
      } else if (this.step === 3) {
        this.noModify = true
        this.noDelete = true
      } else if (this.step === 4) {
        this.noModify = true
        this.noDelete = true
      }
    }
  },
  mounted() {
    this.getActivityStatus();
    this.getScheduledActivity();
    this.getTimeTypesClassification();
    this.getExecutionStatus();
  },
};
</script>
